import $ from 'jquery'
import SpinJS from 'spin.js'

/**
 * @param {Object} config
 * @constructor
 */
export default function Spinner(config) {
  $.extend(this, config || {})

  this.looks = {
    lines: 11, // The number of lines to draw
    length: 15, // The length of each line
    width: 13, // The line thickness
    radius: 25, // The radius of the inner circle
    corners: 0.7, // Corner roundness (0..1)
    rotate: 0, // The rotation offset
    direction: 1, // 1: clockwise, -1: counterclockwise
    color: this.color || '#000', // #rgb or #rrggbb or array of colors
    speed: 1.1, // Rounds per second
    trail: 57, // Afterglow percentage
    shadow: false, // Whether to render a shadow
    hwaccel: false, // Whether to use hardware acceleration
    className: 'spinner', // The CSS class to assign to the spinner
    zIndex: 2e9, // The z-index (defaults to 2000000000)
    top: '50%', // Top position relative to parent
    left: '50%' // Left position relative to parent
  }

  this.defaultTimeout = 15000 // 15s
  this.timer = null

  this.spinner = new SpinJS(this.looks)
  this.spinnerWrapper = $('#spinner-wrapper')
}

/**
 * Start spinner init UI elements
 * @param  {Number} timeout [Timeout in milliseconds]
 */
Spinner.prototype.start = function(timeout) {
  this.spinnerContainer = $('<div></div>')
    .css({
      'position': 'absolute',
      'top': 0,
      'left': 0,
      'width': '100%',
      'height': '100%',
      'z-index': 10000
    })
    .appendTo(this.spinnerWrapper)

  this.spinnerElement = $('<div></div>').appendTo(this.spinnerContainer)

  var timeoutInMs = timeout || this.defaultTimeout

  this.spinner.spin(this.spinnerElement.get(0))

  this.timer = setTimeout(() => this.stop(), timeoutInMs)
}

/**
 * Stop spinner and remove UI elements
 */
Spinner.prototype.stop = function() {
  this.spinner.stop()
  if (this.spinnerContainer) {
    this.spinnerContainer.remove()
  }
  clearTimeout(this.timer)
}
